
import $ from 'jquery';
import config from '../../../config';

export function get_users(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'compassionate_leave/',
			data: {
                method: 'COMP_GET_USERS'
            }
		})
		.then(function (response) {
			dispatch({
				type: "COMP_GET_USERS",
				compleave: response
			})
		})

	}
}

export function save_compassionate_leave( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'compassionate_leave/',
			data: {
				method: 'COMP_SAVE_LEAVE',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "COMP_SAVE_LEAVE",
				compleave: response
			})
		})

	}
}

export function get_compassionate_leave(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'compassionate_leave/',
			data: {
				method: 'COMP_GET_LEAVE',
            }
		})
		.then(function (response) {
			dispatch({
				type: "COMP_GET_LEAVE",
				compleave: response
			})
		})

	}
}

export function delete_compassionate_leave( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'compassionate_leave/',
			data: {
				method: 'COMP_DELETE_LEAVE',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "COMP_DELETE_LEAVE",
				compleave: response
			})
		})

	}
}

export function update_compassionate_leave( id, start_date, end_date ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'compassionate_leave/',
			data: {
				method: 'COMP_UPDATE_LEAVE',
				id: id,
				start_date: start_date, 
				end_date: end_date
            }
		})
		.then(function (response) {
			dispatch({
				type: "COMP_UPDATE_LEAVE",
				compleave: response
			})
		})

	}
}




// WEBPACK FOOTER //
// ./src/pages/compassionate_leaves/actions/leave.action.js